import { ProcessDataOriginEnum } from '../types'

export const PROCESS_ORIGIN_META: Record<
  ProcessDataOriginEnum,
  { abbrev: string; hint: string; detail: string }
> = {
  [ProcessDataOriginEnum.TASK_MINER]: {
    abbrev: 'TM',
    hint: 'Task Mining',
    detail: 'Process data discovered via Process Intelligence Task Miners.',
  },
  [ProcessDataOriginEnum.PM_PLATFORM]: {
    abbrev: 'PM',
    hint: 'ProcessMaker',
    detail: 'Data synced from the ProcessMaker Platform integration.',
  },
}

interface Props {
  origin: ProcessDataOriginEnum
}

const ProcessOriginBadge = ({ origin }: Props) => {
  const meta = PROCESS_ORIGIN_META[origin] ?? {
    abbrev: '?',
    hint: 'Unknown',
    detail: String(origin),
  }

  return (
    <span className='inline-flex max-w-44 shrink-0 items-center gap-1.5 rounded-md border border-slate-200/80 bg-slate-50 px-1.5 py-0.5'>
      <span className='font-mono text-[10px] font-bold uppercase tracking-wider text-slate-600'>
        {meta.abbrev}
      </span>
      <span className='truncate text-[9px] font-medium leading-tight text-slate-500'>
        {meta.hint}
      </span>
    </span>
  )
}

export default ProcessOriginBadge

